export default "__VITE_ASSET__gU6Q1fS9__"